import React from 'react';
import { Container, BHANSALogo, AntEngineLogo } from './VerificationPanel.style';
import VerificationForm from '../verificationForm/VerificationForm';

const VerificationPanel = () => (
  <Container>
    <BHANSALogo href="https://www.bhansa.gov.ba/" target="_blank" />
    <VerificationForm />
    <AntEngineLogo href="https://www.antecna.com/" target="_blank" />
  </Container>
  );

export default VerificationPanel; 